import { useGraphStore } from "./store";
import { ReactFlow, Controls, Background } from "@xyflow/react";

import CustomBackEdge from "./custom-back-edge";
import CustomEdge from "./custom-edge.jsx";
import CustomNode from "./custom-node";
import { useEffect } from "react";
import "@xyflow/react/dist/style.css";
import GraphEditComponent from "../graph-edit-component.jsx";
import { apiGetAvpGrafo } from "../../shared/manager/api_manager";

export default function NewGraph({
  tipiAvvio,
  lingue,
  currentLingua,
  nodeActionCallback,
}) {
  const {
    edges,
    avp,
    nodes,
    onNodesChange,
    onEdgesChange,
    onConnect,
    setEdges,
    selectedNode,
    setSelectedNode,
    start,
  } = useGraphStore((state) => state);

  useEffect(() => {
    if (avp.nodi && avp.nodi.length > 0) {
      start();
    }
  }, [avp]);
  const edgeTypes = {
    customEdge: CustomEdge,
    customBackEdge: CustomBackEdge,
  };

  const nodeTypes = {
    textUpdater: CustomNode,
  };
  const onEdgeMouseEnter = (_, edge) => {
    const updateEdge = edges.map((e) =>
      e.id === edge.id
        ? { ...edge, data: { ...edge.data, isHovered: true } }
        : e
    );
    setEdges(updateEdge);
  };

  const onEdgeMouseLeave = (_, edge) => {
    const updateEdge = edges.map((e) =>
      e.id === edge.id
        ? { ...edge, data: { ...edge.data, isHovered: false } }
        : e
    );
    setEdges(updateEdge);
  };
  const onNodeClick = (_, node) => {
    setSelectedNode(node.id);
  };

  return (
    <>
      {selectedNode && avp && (
        <GraphEditComponent
          tipiAvvio={tipiAvvio}
          avpAssistente={avp}
          lingue={lingue}
          currentLingua={currentLingua}
          nodeActionCallback={nodeActionCallback}
        />
      )}

      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onNodeClick={onNodeClick}
        onConnect={onConnect}
        onEdgeMouseEnter={onEdgeMouseEnter}
        onEdgeMouseLeave={onEdgeMouseLeave}
        // onNodeDrag={onNodeDrag}
        // nodesDraggable={false}
        edgeTypes={edgeTypes}
        nodeTypes={nodeTypes}
        fitView
        // fitViewOptions={fitViewOptions}
        // defaultEdgeOptions={defaultEdgeOptions}
      >
        <Background />
        <Controls position="top-right" />
      </ReactFlow>
    </>
  );
}
